

































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Users from '@/store/modules/Users';
import SignUpDialog from '@/views/Auth/SignUpDialog.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Comments from '@/store/modules/Comments';
import MainCommentPanel from '@/components/common/MainCommentPanel.vue';

const usersModule = getModule(Users);
const workspaceOptionsModule = getModule(WorkspaceOptions)

@Component({
    components: {
        SignUpDialog,
        ChoiceScorer: () =>
            import('@/views/ChoiceViewpointsScorer/ChoiceViewpointsScorer.vue'),
        MainCommentPanel
    },
})
export default class CompareViewpointDialog extends Vue {


    @Prop({type: Boolean, default: false})
    autofill!: boolean;

    @Prop({type: Boolean, default: null})
    
    open!: boolean | null;

    get commentRightWidth() {
        return workspaceOptionsModule.commentRightWidth;
    }

    get dialog(){
        return workspaceOptionsModule.dialog;
    }

    set dialog(val: boolean) {
        workspaceOptionsModule.setDialog(val);
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    set pinnedRight(val) {
        workspaceOptionsModule.setPinnedRight(val);
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    set commentVertical(vertical) {
        workspaceOptionsModule.setCommentVertical(vertical);
    }


    @Watch('open', {immediate: true}) 
    onOpenChanged(newVal: boolean, oldVal: boolean) {
        this.dialog = (this.open === true);
    }

    @Watch('dialog') 
    onDialogChanged(newVal: boolean, oldVal: boolean) {
        this.$emit('clicked', newVal);
    }

    private navDrawer = false;

    get isLoggedIn(): boolean {
        return usersModule.currentAuthUser !== null;
    }

    get openRight() {
        return workspaceOptionsModule.openRight;
    }

    set openRight(val) {
        workspaceOptionsModule.setOpenRight(val);
    }

    // link the dialog open and close to the vuex app module property compareChocieDialog
    // avoid parent child relationship
    // get compareChoiceDialog() {
    //     return appsModule.compareChoiceDialog;
    // }
    // set compareChoiceDialog(val: boolean) {
    //     appsModule.setCompareChoiceDialog(val);
    // }
}
